import React from 'react'
import { observer } from 'mobx-react-lite'

import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Stack from '@mui/material/Stack'

import { H2, H3, Icon, P } from '@mxenabled/mxui'
import { useTheme } from '@mui/material/styles'
import { useCashflowStore, useGlobalCopyStore } from '../../../common'

interface StepOneProps {
  handleNextStep: () => void
}

const StepOne: React.FC<StepOneProps> = ({ handleNextStep }) => {
  const { completeOnboarding } = useCashflowStore()
  const { cashflow: customCopy } = useGlobalCopyStore()

  const theme = useTheme()

  return (
    <Stack>
      <H2 pb={12} variant="h1">
        {customCopy.welcome_title}
      </H2>
      <H3 color={theme.palette.primary.light} pb={8}>
        {customCopy.welcome_sub_title}
      </H3>
      <P pb={32}>{customCopy.welcome_description}</P>
      <Stack direction="column" mb={32} spacing={32}>
        <P sx={{ display: 'flex', alignItems: 'center', fontSize: 18 }}>
          <Box
            bgcolor={theme.palette.primary.lighter}
            borderRadius={1}
            component="span"
            height={44}
            mr={24}
            sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}
            width={44}
          >
            <Icon color="primary" name="currency_exchange" />
          </Box>
          {customCopy.bullet_one}
        </P>
        <P sx={{ display: 'flex', alignItems: 'center', fontSize: 18 }}>
          <Box
            bgcolor={theme.palette.primary.lighter}
            borderRadius={1}
            component="span"
            height={44}
            mr={24}
            sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}
            width={44}
          >
            <Icon color="primary" name="cardiology" />
          </Box>
          {customCopy.bullet_two}
        </P>
        <P sx={{ display: 'flex', alignItems: 'center', fontSize: 18 }}>
          <Box
            bgcolor={theme.palette.primary.lighter}
            borderRadius={1}
            component="span"
            height={44}
            mr={24}
            sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}
            width={44}
          >
            <Icon color="primary" name="flare" />
          </Box>
          {customCopy.bullet_three}
        </P>
      </Stack>
      <Stack direction="row" spacing={16}>
        <Button onClick={handleNextStep} variant="contained">
          {customCopy.get_started_button}
        </Button>
        <Button onClick={completeOnboarding} variant="outlined">
          {customCopy.skip_button}
        </Button>
      </Stack>
    </Stack>
  )
}

export default observer(StepOne)
